import { render, staticRenderFns } from "./SaldoRifModal.vue?vue&type=template&id=567e3e3e"
import script from "./SaldoRifModal.vue?vue&type=script&lang=js"
export * from "./SaldoRifModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567e3e3e')) {
      api.createRecord('567e3e3e', component.options)
    } else {
      api.reload('567e3e3e', component.options)
    }
    module.hot.accept("./SaldoRifModal.vue?vue&type=template&id=567e3e3e", function () {
      api.rerender('567e3e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/SaldoRifModal.vue"
export default component.exports